$(function () {
  initComparisonCards();

  window.addEventListener("resize", debounce(function () {
    initComparisonCards();
  }));

  function debounce(func) {
    var timer;
    return function (event) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(func, 100, event);
    };
  }
});

function initComparisonCards() {
  let $blocks = $('.js-comparison-block');
  $blocks.each(function () {
    let $this = $(this);
    let biggestTitleHeight = 0;
    let biggestIngressHeight = 0;
    let $titleElements = $this.find('.js-comparison-block-title');
    let $ingressElements = $this.find('.js-comparison-block-ingress');
    $titleElements.css('height', 'auto');
    $ingressElements.css('height', 'auto');

    if (window.innerWidth >= 722) {
      $titleElements.each(function () {
        let $title = $(this);
        if ($title.outerHeight() > biggestTitleHeight) {
          biggestTitleHeight = $title.outerHeight();
        }
      });
      $titleElements.css('height', biggestTitleHeight + 'px');

      $ingressElements.each(function () {
        let $ingress = $(this);
        if ($ingress.outerHeight() > biggestIngressHeight) {
          biggestIngressHeight = $ingress.outerHeight();
        }
      });
      $ingressElements.css('height', biggestIngressHeight + 'px');
    }
      
  });
};
